export default __webpack_public_path__ + "static/media/Apple iPad 10.2 (2020).80479947.png";